import { render, staticRenderFns } from "./CategoryProductPrice.vue?vue&type=template&id=4655860e&"
import script from "./CategoryProductPrice.vue?vue&type=script&lang=ts&"
export * from "./CategoryProductPrice.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryProductPrice.vue?vue&type=style&index=0&id=4655860e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports